import { FC, PropsWithChildren } from 'react';

import { Box, SxProps, Theme } from '@mui/material';
import { useSettingsStore } from 'app/store';

interface IProps extends PropsWithChildren {
  sx?: SxProps<Theme>;
}

export const HeaderWrapper: FC<IProps> = ({ children, sx }) => {
  const { darkTheme } = useSettingsStore();
  return (
    <Box
      gridColumn='2'
      gridRow='1'
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        minHeight: '72.5px',
        gap: 10,
        py: 7,
        px: 8,
        borderRadius: 4,
        bgcolor: 'var(--mui-palette-background-paper)',
        border: '1px solid',
        borderColor: darkTheme ? 'var(--mui-palette-divider)' : 'transparent',
        ...sx
      }}>
      {children}
    </Box>
  );
};
